<template>
    <SwitchGroup as="div" class="flex items-center mr-4 md:flex">
        <Switch
            :default-checked="modelValue"
            @update:modelValue="$emit('update:modelValue', $event)"
            :class="[modelValue ? 'bg-cyan-500' : 'bg-gray-200', 'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-minplan-beige']">
                    <span aria-hidden="true"
                          :class="[modelValue ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200']"/>
        </Switch>
        <SwitchLabel as="span" class="ml-3">
            <span class="text-sm font-medium text-gray-900">{{ label }}</span>
        </SwitchLabel>
    </SwitchGroup>
</template>

<script>
import {Switch, SwitchGroup, SwitchLabel} from "@headlessui/vue";

export default {
    props: {
        label: {type: String},
        modelValue: {type: Boolean, default: false}
    },
    emits: ['update:modelValue'],
    components: {
        SwitchLabel,
        Switch,
        SwitchGroup
    }
}
</script>

<style scoped>

</style>
